// Pre-fill the note for single edit (cell click or one selected row); empty for multi-row bulk.
export const getInitialNote = (params) => {
  if (!params.isBulkEdit) {
    return params.value || "";
  }
  if (Array.isArray(params.data) && params.data.length === 1) {
    return params.data[0]?.shipmentComments || "";
  }
  return "";
};
